import {luhnCheck} from '@product-web/validation/helper'

import Country from './country'

const isNationalIdValid = (value: string, country: string) => {
    switch (country) {
        case Country.DK:
            return /^(\d{6})-?\d{4}$/.test(value)

        case Country.SE: {
            // Swedish national ids can be 10 or 12 digits long. If 10,
            // they have a single "-" or "+". If 12, they only contain
            // digits and the first two are left out for validation
            // https://swedish.identityinfo.net/personalidentitynumber
            // https://en.wikipedia.org/wiki/Personal_identity_number_(Sweden)#Checksum
            const isValid = /^(\d{6}|\d{8})(\+|-)?\d{4}$/.test(value)

            if (!isValid) {
                return false
            }

            const valueDigitsOnly = value.replace(/[^\d]/, '')

            const formattedValue = valueDigitsOnly.slice(-10)

            return luhnCheck(formattedValue)
        }

        case Country.ES:
            // non-Spain born: 9 characters total, of those one letter at the beginning, seven digits, one letter at the end
            // Spain born: 9 characters total, eight digits, one letter at the end
            return /^[A-Z\d]\d{7}[A-Z]$/i.test(value)

        // Source: https://success.myshn.net/Skyhigh_Data_Protection/Data_Identifiers/European_Personal_Identity
        case Country.IT:
            return /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/.test(
                value,
            )

        // Source: https://success.myshn.net/Skyhigh_Data_Protection/Data_Identifiers/European_Personal_Identity
        case Country.FI:
            return /^([0-3]\d)([0-1]\d)(\d{2})[A\-+](\d{3})(\d|[A-Z])$/.test(value)

        // Source: https://success.myshn.net/Skyhigh_Data_Protection/Data_Identifiers/European_Personal_Identity
        case Country.NO:
            return /^\d{2}[01]\d{3}\s?\d{5}$/.test(value)

        default:
            return true
    }
}

export default isNationalIdValid
